export const Providers = Object.freeze({
  ExpressOne: {
    labelProviderId: '1',
    labelProviderIdInt: 1,
  },
  Stamps: {
    labelProviderId: '2',
    labelProviderIdInt: 2,
  },
  USPS: {
    labelProviderId: '2',
    labelProviderIdInt: 2,
  },
  UPS: {
    labelProviderId: '3',
    labelProviderIdInt: 3,
  },
  FedEx: {
    labelProviderId: '4',
    labelProviderIdInt: 4,
  },
  Endicia: {
    labelProviderId: '5',
    labelProviderIdInt: 5,
  },
  DhlExpress: {
    labelProviderId: '13',
    labelProviderIdInt: 13,
  },
  FirstMile: {
    labelProviderId: '16',
    labelProviderIdInt: 16,
  },
  IntersoftRoyalMail: {
    labelProviderId: '20',
    labelProviderIdInt: 20,
  },
  AmazonBuyShipping: {
    labelProviderId: '27',
    labelProviderIdInt: 27,
  },
  StampsWhitelabel: {
    labelProviderId: '34',
    labelProviderIdInt: 34,
  },
  Hermes: {
    labelProviderId: '39',
    labelProviderIdInt: 39,
  },
  ParcelForce: {
    labelProviderId: '44',
    labelProviderIdInt: 44,
  },
  DPD: {
    labelProviderId: '57',
    labelProviderIdInt: 57,
  },
  Canpar: {
    labelProviderId: '60',
    labelProviderIdInt: 60,
  },
  AmazonShippingUS: {
    labelProviderId: '80',
    labelProviderIdInt: 80,
  },
  AmazonShippingUK: {
    labelProviderId: '81',
    labelProviderIdInt: 81,
  },
  UPSWallet: {
    labelProviderId: '103',
    labelProviderIdInt: 103,
  },
  Canpar1B: {
    labelProviderId: '104',
    labelProviderIdInt: 104,
  },
  ClientStamps: {
    labelProviderId: '109',
    labelProviderIdInt: 109,
  },
  ClientFedex: {
    labelProviderId: '116',
    labelProviderIdInt: 116,
  },
  ClientUPS: {
    labelProviderId: '117',
    labelProviderIdInt: 117,
  },
  CanadaPost1B: {
    labelProviderId: '127',
    labelProviderIdInt: 127,
  },
  Uber: {
    labelProviderId: '137',
    labelProviderIdInt: 137,
  },
  UberWallet: {
    labelProviderId: '143',
    labelProviderIdInt: 143,
  },
  ClientDhlExpress: {
    labelProviderId: '145',
    labelProviderIdInt: 145,
  },
  ClientDhlExpressByShipStation: {
    labelProviderId: '146',
    labelProviderIdInt: 146,
  },
  ClientDhlEcommerce: {
    labelProviderId: '149',
    labelProviderIdInt: 149,
  },
  ClientSharedCarriers: {
    labelProviderId: '150',
    labelProviderIdInt: 150,
  },
  FedExWalleted: {
    labelProviderId: '194',
    labelProviderIdInt: 194,
  },
  AustraliaPostMyPostBusinessWalleted: {
    labelProviderId: '4179',
    labelProviderIdInt: 4179,
  },
  AmazonShippingWalleted: {
    labelProviderId: '180',
    labelProviderIdInt: 180,
  },
  DhlExpressByShipStation: {
    labelProviderId: '38',
    labelProviderIdInt: 38,
  },
  RoyalMailClickAndDropWalleted: {
    labelProviderId: '4421',
    labelProviderIdInt: 4421,
  },
  FedexUKWalleted: {
    labelProviderId: '4312',
    labelProviderIdInt: 4321,
  },
  WWEX: {
    labelProviderId: '4690',
    labelProviderIdInt: 4690,
  },
  UpsInvoicedByShipStation: {
    labelProviderId: '4790',
    labelProviderIdInt: 4790,
  },
  Unishippers: {
    labelProviderId: '4692',
    labelProviderIdInt: 4692,
  },
  TikTokShipping: {
    labelProviderId: '4700',
    labelProviderIdInt: 4700,
  },
});

export const stampsAndEndiciaLabelProviderIds = [
  Providers.Stamps.labelProviderId,
  Providers.ClientStamps.labelProviderId,
  Providers.StampsWhitelabel.labelProviderId,
  Providers.Endicia.labelProviderId,
];

export const yourCarriersFeeExcludedInt = [
  Providers.Stamps.labelProviderIdInt,
  Providers.ClientStamps.labelProviderIdInt,
  Providers.StampsWhitelabel.labelProviderIdInt,
  Providers.Endicia.labelProviderIdInt,
  Providers.AmazonShippingUS.labelProviderIdInt,
  Providers.AmazonShippingUK.labelProviderIdInt,
  Providers.FirstMile.labelProviderIdInt,
  Providers.ClientFedex.labelProviderIdInt,
  Providers.ClientUPS.labelProviderIdInt,
  Providers.ClientDhlExpress.labelProviderIdInt,
  Providers.ClientDhlExpressByShipStation.labelProviderIdInt,
  Providers.ClientDhlEcommerce.labelProviderIdInt,
  Providers.ClientSharedCarriers.labelProviderIdInt,
];

/**
 * Label provider IDs for carriers that are considered non-default.
 * These providers show different UI states when wallets are not
 * activated automatically on wallet signup and instead require internal approval.
 * @type {Set<string>}
 */
export const nonDefaultWalletSellerLabelProviderIdsSet = new Set([
  Providers.FedExWalleted.labelProviderId,
  Providers.AmazonShippingWalleted.labelProviderId,
]);

/**
 * @deprecated Prefer `isAlwaysAllowed` from `/IntegrationsPlatform/displayInfo/providers` (via DataCache)
 * Two call sites still use this function and cannot be removed until those call sites are refactored:
 * - `selectNonWalletedAndNonExcludedSellerLabelProviders` (use-seller-label-providers.js) — operates on Redux SLP data
 * - `useIsCarrierRowDisabled` (carriers-page-display-hooks.js) — same; only affects old byoa_billing_2023_q2 plan sellers
 *
 * `connect-label-provider-modal/context-provider.jsx` has already been migrated to `provider.isAlwaysAllowed`.
 *
 * @param {string} labelProviderId
 * @returns {boolean}
 */
export const getIsLabelProviderIdExcludedFromYourCarriersFee = (labelProviderId) => {
  return yourCarriersFeeExcludedInt.some((lpid) => lpid === parseInt(labelProviderId, 10));
};

const byolOnlyLabelProviderIds = new Set([Providers.TikTokShipping.labelProviderIdInt]);

export const isByolOnlyLabelProvider = (labelProviderId) => byolOnlyLabelProviderIds.has(parseInt(labelProviderId, 10));

/**
 * Label provider IDs whose BYOA seller-providers expose a "Refresh services" action,
 * which calls the backend to re-fetch the account's enabled services from the carrier.
 * @type {Set<string>}
 */
export const refreshServicesLabelProviderIds = new Set([Providers.WWEX.labelProviderId, Providers.Unishippers.labelProviderId]);
